module.exports = __webpack_public_path__ + "img/Dantam Hair 26.68bdfa50.jpg";